import React from 'react';
import {Icons, DynamicContainer, Edit, TimeTagPicker, List} from 'components';
import {bounce, keyBy, filter, reject, sortBy, useField, useEditableList, useDragStart, useGlobalDrop} from 'helpers';
import css from './subtasks.module.scss';

export function SubTasks(props) {
  const [ { value }, , { setValue } ] = useField(props);
  const list = useEditableList(value, setValue, 'name');

  useGlobalDrop(grabbed => grabbed.type === 'subtask', (event, grabbed) => {
    bounce(grabbed.target);
    const list = grabbed.target.closest('[aria-roledescription="list"]');
    const nodes = keyBy(list.querySelectorAll('[draggable]'), 'dataset.id');
    setValue(sortBy(value, ({id}) => {
      return id === grabbed.id ? grabbed.clientY : nodes[id].getBoundingClientRect().y;
    }));
  });

  return (
    <DynamicContainer>
      <List tiny-gutter className={css.list}>
        { reject(value, { status: 'Completed' }).map(item =>
          <div key={item.id} data-id={item.id} {...useDragStart({id: item.id, type: 'subtask'})}>
            <Edit
              name={item.id}
              onKeyDown={list.onKeyDown}
              placeholder="Enter Subtask.."
              Prefix={Handle}
              setValue={list.setValue}
              status={item.status}
              Suffix={item.name && SubTaskTime}
              time={item.time}
              value={item.name}
            />
          </div>
        ) }
        { filter(value, { status: 'Completed' }).map(item =>
          <div key={item.id} className={css.completed} data-id={item.id}>
            <Edit
              name={item.id}
              onKeyDown={list.onKeyDown}
              placeholder="Enter Subtask.."
              setValue={list.setValue}
              status={item.status}
              remove={() => setValue(reject(value, ({ id }) => id == item.id))}
              time={item.time}
              value={item.name}
              muted
              Suffix={Remove}
            />
          </div>
        ) }
      </List>
    </DynamicContainer>
  );
}

function Handle({ value }) {
  return Boolean(value) && (
    <span className={css.prefix}>
      <Icons.HandleAlt />
    </span>
  );
}

function Remove({ remove }) {
  return (
    <Icons.CloseSmall className="secondary" onClick={remove} />
  );
}

function SubTaskTime({ setValue, name, time }) {
  return (
    <TimeTagPicker placeholder="+ time" value={time} setValue={time => setValue(time, name, 'time')} />
  );
}
